declare var _users_limit_reached: boolean


export const legacyHandleAddMemberModal = () => {
  if (_users_limit_reached) {
    $('#usersLimitReachedModal').modal('show');
  } else {
    $('#newUserModal').modal('show');
  }
}
